import 'css-chunksrc/client/common/layout/zonesList/zone/projectsList/styles.scss';export default {
  "projectsList": "_projectsList_5qi6c_1",
  "item": "_item_5qi6c_8"
};